<template>
  <sf-modal-portal modal-id="file-followers-modal" size="xs">
    <template #title
      >{{ I18n.t('company.following.file_followers') }}
    </template>
    <template #body>
      <div class="tw-flex tw-flex-col tw-gap-2">
        <div class="tw-font-bold tw-mb-3">
          {{
            I18n.t('company.following.followers_for', {
              count: followCount,
              file_name: companyName,
            })
          }}
        </div>
        <div
          class="tw-bg-sf-snow tw-rounded-lg tw-h-60 tw-overflow-auto tw-mb-2"
        >
          <sf-list :no-margin="true">
            <sf-list-item
              v-if="isCurrentUserFollowing && currentUser"
              :item-id="currentUser.id.toString()"
              background="transparent"
              :default-cursor="true"
            >
              {{
                I18n.t('company.following.myself', { name: currentUser.name })
              }}
            </sf-list-item>
            <sf-list-item
              v-for="(name, id) in followers"
              :key="id.toString()"
              :item-id="id.toString()"
              background="transparent"
              :default-cursor="true"
            >
              {{ name }}
            </sf-list-item>
          </sf-list>
        </div>
        <div class="sf-c-text-light tw-text-left">
          {{ I18n.t('company.following.modal_hint') }}
        </div>
        <div v-if="readMoreUrl">
          <a
            :href="readMoreUrl"
            target="_blank"
            class="sf-a sf-a-secondary tw-text-left"
          >
            {{ I18n.t('company.following.read_more') }}
            <span class="icon icon-external-link"></span>
          </a>
        </div>
      </div>
    </template>
  </sf-modal-portal>
</template>

<script lang="ts" setup>
import SfModalPortal from '@app/shared/vue/components/sf-modal/sf-modal-portal.vue'
import sfList from '@app/shared/vue/components/sf-list/sf-list.vue'
import sfListItem from '@app/shared/vue/components/sf-list/sf-list-item.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useCompanyFollowStore } from '../stores/use-company-follow-store'
import { storeToRefs } from 'pinia'
import { getCompanyName } from '@app/adapters/silverfin'

const followStore = useCompanyFollowStore()
const { followCount, followers, isCurrentUserFollowing, currentUser } =
  storeToRefs(followStore)

interface Props {
  readMoreUrl: string
}

defineProps<Props>()

defineOptions({
  name: 'FileFollowersModal',
})

const I18n = useI18n()
const companyName = getCompanyName()
</script>
